import { MarkData, SaturationCurveKeyPoints } from "../types/saturationCurve";

export const markerConfig = [
  { name: "Lower Threshold", key: "lowerThreshold" },
  { name: "Upper Threshold", key: "upperThreshold" },
  { name: "Current Spend", key: "currentSpend" },
  { name: "Max Efficiency", key: "maxEfficiency" },
] as const;

export const generateMarkData = (keyPoints: Partial<SaturationCurveKeyPoints>): MarkData[] => {
  return markerConfig.map(({ name, key }) => ({
    key,
    name,
    markCoordinates: keyPoints[key] ?? {},
  })) as MarkData[];
};
